import { Shield, Lock, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';

export const SecurityCompliance = () => {
  return (
    <section className="py-8 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <motion.h2 
            className="text-xl md:text-2xl font-bold text-center mb-2"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Your Data Security is Our Priority
          </motion.h2>
          
          <motion.div 
            className="h-0.5 w-16 bg-primary/40 mx-auto mb-8 rounded-full"
            initial={{ opacity: 0, width: 0 }}
            whileInView={{ opacity: 1, width: 64 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          ></motion.div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
            {/* HIPAA Compliance */}
            <motion.div 
              className="flex flex-col items-center text-center"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="bg-card p-4 rounded-xl shadow-sm mb-3 border flex items-center justify-center h-32 w-full hover-lift">
                <img 
                  src="/lovable-uploads/f42fbb46-419c-448b-894f-f17826befc07.png" 
                  alt="HIPAA Compliant Database" 
                  className="h-20 w-auto object-contain"
                />
              </div>
              <h3 className="text-sm font-semibold flex items-center">
                <Shield className="w-4 h-4 text-primary mr-1" />
                HIPAA Compliant
              </h3>
            </motion.div>
            
            {/* Trust Center - Central CTA */}
            <motion.div 
              className="flex flex-col items-center text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-primary/5 border-2 border-primary/20 p-6 rounded-xl mb-3 h-32 w-full flex flex-col items-center justify-center">
                <Shield className="w-8 h-8 text-primary mb-2" />
                <h3 className="text-base font-bold mb-1">Trust Center</h3>
                <p className="text-xs text-muted-foreground mb-3">View our security documentation</p>
                <Button size="sm" variant="outline" className="text-xs" asChild>
                  <a href="https://trust.delve.co/the-peo-app" target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="w-3 h-3 mr-1" />
                    Learn More
                  </a>
                </Button>
              </div>
            </motion.div>
            
            {/* SOC II Compliance */}
            <motion.div 
              className="flex flex-col items-center text-center"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="bg-card p-4 rounded-xl shadow-sm mb-3 border flex items-center justify-center h-32 w-full hover-lift">
                <img 
                  src="/lovable-uploads/7ccd4655-c56f-44d3-af4c-32e7edcb59df.png" 
                  alt="SOC II Compliant Database" 
                  className="h-20 w-auto object-contain"
                />
              </div>
              <h3 className="text-sm font-semibold flex items-center">
                <Lock className="w-4 h-4 text-primary mr-1" />
                SOC II Compliant
              </h3>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};